export enum ResultConstant {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  ABORTED = 'ABORTED',
  NOT_EXECUTED = 'NOT_EXECUTED',
  PRE_REQUISITE_FAILURE = 'PRE_REQUISITE_FAILURE',
  QUEUED = 'QUEUED',
  STOPPED = 'STOPPED',
  PAUSED = 'PAUSED',
  SKIPPED = 'SKIPPED',
  RUNNING = 'RUNNING',
}
